import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators,AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { Router } from '@angular/router';
import { CatEditService } from 'src/app/services/cat-edit.service';
import { DataTransferService } from '../data-transfer.service';
import { StorageService } from 'src/app/services/storage.service';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-product-details',
    templateUrl: './product-details.component.html',
    styleUrls: ['./product-details.component.scss'],
    standalone: false
})
export class ProductDetailsComponent implements OnInit {
  states: any;
  fileName: string = 'Browse';
  productDetails: FormGroup;
  selectedDocumentType = '';
  submitted: boolean = false;
  showTemplatePage: boolean = false;
  showUploadPage: boolean = true;
  selectedBranch: any = {};
  @Input() productDetailsData: any = [];
  allTemplateDoc: any = [];
  accountData: any = {};
  @Output() productDetailsChange: EventEmitter<any> = new EventEmitter<[]>();
  enableRefIdField: boolean;
  noBranch: boolean = false;
  selectedValue: any;
  private branchSubscription: Subscription;
  showHdfcFields: boolean = true;
  organisationId: any;
  referenceIdValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;
      const validPattern = /^[a-zA-Z0-9_-]*$/;
      return validPattern.test(value) ? null : { invalidChars: true };
    };
  }
  constructor(
    private formBuilder: FormBuilder,
    private storageService: StorageService,
    private catEditService: CatEditService,
    private messageService: MessageService
  ) {
    this.productDetails = this.formBuilder.group({
      branchName: ['Selected Branch', [Validators.required]],
      referenceNumber: ['',[Validators.maxLength(80),Validators.required,this.referenceIdValidator()]],
      documentType: [null, [Validators.required]],
    });

    this.userDetails();
    this.organisationId = this.storageService.getOrganization() || '';
    this.showHdfcFields = this.organisationId === 'HDHO';
  }

  ngOnInit(): void {
    this.getRefIdConsent();
    this.setSelectedBranchValue();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.productDetailsData.currentValue) {
      const data = changes.productDetailsData.currentValue;
      if (data) {

        this.productDetails.controls['branchName'].setValue(
          data.name
        );
        this.noBranch = false;
      }
    }

  }


  setSelectedBranchValue() {
    this.selectedValue = this.storageService.getBranch()|| null;
    this.productDetails.controls['branchName'].setValue(
      this.selectedValue.name
    );
    this.branchSubscription = this.storageService.branchChange.subscribe((branch: any) => {
      this.selectedBranch = branch;
      this.productDetails.controls['branchName'].setValue(branch.name);
    });
  }

  getRefIdConsent() {
    let refIdConsent = this.storageService.getRefIdConsent()|| null;
    if (refIdConsent === true) this.enableRefIdField = true;
    else {
      this.enableRefIdField = false;
      this.generateReferenceId();
    }
  }

  generateReferenceId() {
    this.catEditService.getOrValidateReferenceId().subscribe(
      (res: any) => {
        if (res.status === 200) {
          //this.messageService.add({ severity: 'success', detail: res.message });
          this.productDetails.controls['referenceNumber'].setValue(
            res.content.reference_id
          );
        }
      },
      (err) => {
        if (
          'error' in err &&
          'content' in err.error &&
          'errors' in err.error.content
        ) {
          this.messageService.add({
            severity: 'error',
            detail: err.error.message,
          });
        }
      }
    );
  }

  validateReferenceId() {
    let enteredReferenceId = this.productDetails.value.referenceNumber;
    this.catEditService.getOrValidateReferenceId(enteredReferenceId).subscribe(
      (res: any) => {
        if (res.status === 200) {

          this.onSendProductDetails();
        }
      },
      (err) => {
        if (
          'error' in err &&
          'content' in err.error &&
          'errors' in err.error.content
        ) {
          this.messageService.add({
            severity: 'error',
            detail: err.error.message,
          });
        }
      }
    );
  }

  userDetails() {
    this.catEditService.getUserDetails().subscribe((res) => {
      this.accountData = res['content'][0];
      this.userTemplate(this.storageService.getAccountId());
    });
  }

  userTemplate(id: any) {
    const param = '?account_id=' + id;
    this.catEditService.getTemplate(param).subscribe((res: any) => {
      this.allTemplateDoc = res['content'];
    });
  }

  gotoTemplatePage() {
    this.submitted = true;

    if (this.productDetails.invalid) {
      this.messageService.add({
        severity: 'warn',
        detail: 'Please fix the errors in the form before proceeding',
      });
      return; 
    }

    if (this.productDetails.value.branchName === 'Selected Branch') {
      this.messageService.add({ severity: 'warn', detail: 'Please select state and branch to proceed' });
      this.noBranch = true
      return;
    }
    if (this.productDetails.invalid) {
      return;
    } else {
      this.validateReferenceId();
    }
  }

  onSendProductDetails() {
    this.productDetailsData = this.productDetails.value;
    this.productDetailsChange.emit(this.productDetailsData);
  }

  selectTemplate() {
    this.submitted = true;
    if (this.productDetails.controls['documentType'].invalid) {
      return;
    } else {
    }
  }

  onReferencePaste(event: ClipboardEvent): void {
    if (!this.enableRefIdField) {
      event.preventDefault();
      return;
    }
    event.preventDefault();
    const clipboardData = event.clipboardData?.getData('text') || '';
    const sanitized = clipboardData.replace(/[^a-zA-Z0-9_-]/g, '');
    const input = event.target as HTMLInputElement;
    const start = input.selectionStart ?? 0;
    const end = input.selectionEnd ?? 0;
    const newValue = input.value.slice(0, start) + sanitized + input.value.slice(end);
    this.productDetails.get('referenceNumber')?.setValue(newValue);
  }
}
